<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-8">
                <h4 class="m-b-0">Buyers in {{currentOrg.express_name}} </h4>
                <p class="text-muted m-t-0">Click view to see information such as billing info, invoices and more.</p>
            </div>
            <div class="col-4">

            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body border-top" v-bind:key="index" v-for="(buyer, index) in buyers">
                        <div class="row m-b-0">
                            <div class="col-lg-3 col-md-6">
                                <div class="d-flex align-items-center">
                                    <div>
                                        <span class="font-weight-bold">Name</span>
                                        <h3 class="font-light m-b-0">{{buyer.org_name}}</h3>
                                        <span class="font-weight-bold">DID</span>
                                        <br>
                                        <a v-if="buyer.did" :href="explorer+'/identity/'+buyer.did" target="_blank">{{buyer.did | truncate(30,'')}}...</a>
                                        <span v-else>N/A</span>
                                        <br>
                                        <span class="font-weight-bold">Audit</span>
                                        <br>
                                        <a v-if="buyer.audit" :href="buyer.audit" target="_blank">{{buyer.audit | truncate(30,'')}}...</a>
                                        <span v-else>N/A</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-6">
                                <div class="d-flex align-items-center">
                                    <div>
                                        <span class="font-weight-bold">Description</span><br>
                                        <span v-html="buyer.org_description" v-if="buyer.org_description"></span>
                                        <span v-else>N/A</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-6">
                                <div class="d-flex align-items-center">
                                    <div>
                                        <span class="font-weight-bold">Address</span>
                                        <address>
                                            <h4 class="font-light m-b-0">{{buyer.biz_name}}</h4>
                                            {{buyer.line1}}
                                            <br> {{buyer.city}} {{buyer.postal_code}}
                                            <br> {{buyer.country}}
                                        </address>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-6">
                                <div class="d-flex ml-auto">
                                    <div>
                                        <span class="font-weight-bold">Actions</span>
                                        <br>
                                        <div aria-label="Button group with nested dropdown" class="btn-group" role="group">
                                            <router-link :to="{name: 'viewbuyer', params: {buyerid: buyer.id}}" class="btn btn-secondary">View</router-link>
                                            <router-link :to="{name: 'editbuyer', params: {buyerid: buyer.id}}" class="btn btn-secondary" type="button">Modify</router-link>
                                            <div class="btn-group" role="group">
                                                <button aria-expanded="false" aria-haspopup="true" class="btn btn-secondary dropdown-toggle" data-toggle="dropdown" id="btnGroupDrop1" type="button">
                                                    <i class="fas fa-cog"></i>
                                                </button>

                                                <div aria-labelledby="btnGroupDrop1" class="dropdown-menu">
                                                    <a @click="selectMember(buyer)" class="dropdown-item" data-target="#confirmModal" data-toggle="modal" href="javascript:void(0)">Remove from
                                                        plan</a>
                                                    <a class="dropdown-item" href="javascript:void(0)">Billing Info</a>
                                                    <a class="dropdown-item" href="javascript:void(0)">Renew</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div aria-hidden="true" aria-labelledby="myModalLabel" class="modal fade" id="confirmModal" role="dialog" tabindex="-1">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <div class="modal-body card-blue">
                                    <div class="text-center m-t-20 m-b-10">
                                        <i class="fa fa-exclamation-triangle text-warning" style="font-size:50px"></i>
                                        <br><br>
                                        <h4>Are you sure you want to remove {{buyer.biz_name}} from plan {{buyer.plan_name}}?</h4>
                                        <button @click="removeMember()" class="btn waves-effect waves-light btn-success m-r-15" data-dismiss="modal" type="button">Yes</button>
                                        <button class="btn waves-effect waves-light btn-danger" data-dismiss="modal" type="button">No</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <paginate
                        :click-handler="pageHandler"
                        :container-class="'pagination float-right'"
                        :margin-pages="2"
                        :next-class="'page-link'"
                        :next-text="'Next'"
                        :page-class="'page-link'"
                        :page-count=pageCount
                        :page-range="3"
                        :prev-class="'page-link'"
                        :prev-text="'Prev'">
                </paginate>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Blockie from "../../../common/Blockie";
    import Paginate from 'vuejs-paginate';

    export default {
        name: "Partners",
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        components: {Blockie, Paginate},
        data() {
            return {
                buyers: [],
                pageCount: 1,
                perPage: 10,
                total: 0,
                buyer: {
                    id: null,
                    biz_name: null
                },
                explorer: ''
            };
        },
        mounted() {
            this.explorer =this.$EXPLORER;
            this.getMembers(1);
        },
        methods: {
            async getMembers(page) {
                try {
                    $(".preloader").fadeIn();
                    let reply = await this.$http
                    .get("/express/" + this.currentOrg.express_id + "/sales/buyers", {
                        params: {
                            page: page,
                            perPage: 10
                        }
                    });
                    $(".preloader").fadeOut();
                    this.total   = reply.data.total;
                    this.buyers = reply.data.buyers;
                    this.setPageCount();
                } catch(e) {
                    $(".preloader").fadeOut();
                    console.log(err);
                }
            },
            pageHandler(pageNum) {
                this.getMembers(pageNum);
            },
            setPageCount() {
                this.pageCount = this.total <= this.perPage ? 1 : Math.ceil(this.total / this.perPage);
            },
            selectMember(buyer) {
                this.buyer = buyer;
            },
            async removeMember() {
            },
        }
    }
</script>

<style scoped>

</style>
